import { GuiBase } from "../GuiBase";

export class GuiLogin2FAQR extends GuiBase {

    constructor() {
        super("Login2FAQR");
    }

}
